import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoute, authRoutes, privateRoutes } from 'routes';
import { AuthLayout, SideBarLayout, NewPatientLayout } from 'layouts';
import { Loading } from 'components';
import { useAuth } from 'contexts/AuthContext';

export const AllRoutes = () => {
	const { user } = useAuth();

	return user === undefined ? (
		<Loading className='bg-orange-light/50 absolute w-full h-screen top-0 left-0' />
	) : (
		<Routes>
			<Route
				path='auth/'
				element={<AuthLayout />}
			>
				{authRoutes.map((route: RouteType) => (
					<Route
						key={route.path}
						path={route.path}
						element={route.element}
					/>
				))}
			</Route>
			{!user.isAdmin && (
				<>
					<Route
						path='new-patient/'
						element={<NewPatientLayout />}
					>
						{privateRoutes
							.filter((r: RouteType) => r.layout === 'NewPatientLayout')
							.map((route: RouteType) => (
								<Route
									key={route.path}
									path={route.path}
									element={<PrivateRoute>{route.element}</PrivateRoute>}
								/>
							))}
					</Route>
				</>
			)}
			<Route
				path='edit-patient/:patientId'
				element={<NewPatientLayout />}
			>
				{privateRoutes
					.filter((r: RouteType) => r.layout === 'NewPatientLayout')
					.map((route: RouteType) => (
						<Route
							key={route.path}
							path={route.path}
							element={<PrivateRoute>{route.element}</PrivateRoute>}
						/>
					))}
			</Route>
			<Route element={<SideBarLayout />}>
				{privateRoutes
					.filter((r: RouteType) => r.layout === 'SideBarLayout')
					.map((route: RouteType) => (
						<Route
							key={route.path}
							path={route.path}
							element={<PrivateRoute>{route.element}</PrivateRoute>}
						/>
					))}
			</Route>
			<Route
				path='*'
				element={
					<Navigate
						to='/patients'
						replace
					/>
				}
			/>
		</Routes>
	);
};
